/* eslint-disable */
import { CountUp } from 'countup.js';
import VideoPlayerFactory from "../../classes/video-player-factory";

const callbacks = {
  /* 'scrollTestFunction' : (way, obj) => {
    // way: enter | exit
    console.log("SCROLL TEST FUNCT");
    console.log(way);
    console.log(obj);
    console.log("SCROLL TEST FUNCT");
  } */
  'countup' : (way, obj) => {
    // way: enter | exit
    // console.log("countup funct");
    // console.log(way);
    // console.log(obj);

    // se l'elemento è un numero countup
    // la classe "cup--enabled" serve ad evitare che al resize i contatori vadano a zero
    // perchè viene eseguito nuovamente il countup
    if( obj.el.classList.contains('cup') && ! obj.el.classList.contains('cup--enabled') ) {

      // compatibilità con nuovo blocco
      let suffix = obj.el.getAttribute('data-suffix') ? '<span class="su">' + obj.el.dataset.suffix + '</span>' : '';
      let prefix = obj.el.getAttribute('data-prefix') ? '<span class="pr">' + obj.el.dataset.prefix + '</span>': '';
      
      obj.el.classList.add('cup--enabled');

      if( obj.el.classList.contains('cup--perc') ) {
        suffix = '<span class="su">%</span>';
      }

      if( obj.el.classList.contains('cup--km') ) {
        suffix = '<span class="su">km</span>';
      }

      if( obj.el.classList.contains('cup--mq') ) {
        suffix = '<span class="su">mq</span>';
      }

      if( obj.el.classList.contains('cup--x') ) {
        suffix = '<span class="su">x</span>';
      }

      if( obj.el.classList.contains('cup--mila') ) {
        suffix = '<span class="su">mila</span>';
      }

      if( obj.el.classList.contains('cup--hour') ) {
        suffix = '<span class="su">ore</span>';
      }

      if( obj.el.classList.contains('cup--mln') ) {
        suffix = '<span class="su">mln</span>';
      }

      if( obj.el.classList.contains('cup--plus') ) {
        prefix = '<span class="pr">+</span>';
      }

      if( obj.el.classList.contains('cup--min') ) {
        prefix = '<span class="pr">-</span>';
      }

      const easingFn = function (t, b, c, d) {
        var ts = (t /= d) * t;
        var tc = ts * t;
        return b + c * (tc + -3 * ts + 3 * t);
      }

      const cupOpt = {
        prefix: prefix,
        suffix: suffix,
        separator: '',
        easingFn,
      };

      const cup = new CountUp(obj.el, obj.el.innerText, cupOpt);
      if ( !cup.error ) {
        cup.start();
      }
    }

  },
  'videoautoplay' : (way, obj) => {
    // way: enter | exit
     /*console.log("videoautoplay funct");
     console.log(way);
     console.log(obj)*/
    //

    const playerFactory = new VideoPlayerFactory();
    const isLottie = obj.el.classList.contains('lottie');

    // se è lottie ed era già stato inizializzato non fa nulla
    if(
      isLottie &&
      obj.el.classList.contains('lottie--init') ){
      return;
    }

    let player = playerFactory.getPlayer(obj.el, isLottie ? 'lottie' : 'html5');

    if(way === 'enter'){
      player.play();
    } else {
      player.stop();
    }


  },
  'stickynav' : (way, obj) => {
    // way: enter | exit
    // console.log("stickynav funct");
    // console.log(way);
    // console.log(obj);


    if( way === 'enter' ) {

      // way: enter | exit
      // console.log("stickynav funct");
      /*
       console.log(way);
       console.log(obj);
       console.log("stickynav" + obj.el.id);
       */

      const links = document.querySelectorAll('.stickylink');

      links.forEach((link) => {
        link.parentElement.classList.remove('sticky--active');
      });

      document.querySelector('a[href="#' + obj.el.id + '"]').parentElement.classList.add('sticky--active');

    }
  }
};

export {
  callbacks
};



// WEBPACK FOOTER //
// ./scripts/classes/scroll-call/callbacks.js